import {
  BACKEND_HOST,
  CONFIGURATION_API_PATH,
  DOCUMENTATION_URL,
  INSIGHTS_API_PATH,
  LOGIN_API_PATH,
  RESOURCES_API_PATH,
  SERVICE_HOST,
} from './env';

export const documentationUrl = DOCUMENTATION_URL;
export const backendHost = BACKEND_HOST || '';
export const serviceHost = SERVICE_HOST || '';

const createPath = (path, defaultPath) => `${backendHost}${path || defaultPath}`;

export const configuration = createPath(CONFIGURATION_API_PATH, '/utilihive-frontend-configuration-server');
export const resources = `${createPath(RESOURCES_API_PATH, '/utilihive-integration-resource-registry')}/api`;
export const login = `${createPath(LOGIN_API_PATH, '/metercloud-integration-identity')}/api`;
export const insights = `${createPath(INSIGHTS_API_PATH, '/metercloud-integration-insights')}/api/v1`;
export const insightsV2 = `${createPath(INSIGHTS_API_PATH, '/metercloud-integration-insights')}/api/v2`;

export const PUBLIC_DOC_PAGES = {
  OIDC_SERVICE_ACCOUNT_JSON_IQ: `${documentationUrl}/connect-platform/flow-access.html#jwt-claims-matching`,
  FOUNDATION_ROOT_CA_CERTIFICATE: `${documentationUrl}/connect-platform/certificate.html#connect-cluster-ca-certificate`,
};
